import Logger from './';
import creator from './kycreator';
export default new Logger({}, creator);
